/*
创建者 魏强(2018.2.7)
店铺列表页面
*/
<template>
  <div id="shop-list-page" style="overflow: hidden">
    <div class="breadcrumb-layout">
      <div class="breadcrumb wrapper">
        <span>
          <router-link to="/">首页</router-link>
        </span>
        <span class="arrow">&gt;</span>
        <span>店铺</span>
      </div>
    </div>
    <div class="container wrapper">
      <div class="sort-bar">
        <div class="shop_con_list" id="main-nav-holder">
          <div class="sort-bar">
            <div class="shop_con_list" id="main-nav-holder">
              <nav class="nc-gl-sort-bar" id="main-nav">
                <div class="sort-bar">
                  <!-- 排序方式S -->
                  <ul class="array">
                    <li :class="{'selected':searchType=='default'}" @click="changeSearchByType('default')">
                      <a href="javascript:void(0)" class="nobg" title="">默认</a>
                    </li>
                    <li :class="{'selected':searchType=='store_credit'}" @click="changeSearchByType('store_credit')">
                      <a href="javascript:void(0)" title="点击按信用从高到低排序">信用</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="squares" v-if="list.length==0&&!loading">
        <span style="color:red;font-size:20px;text-align:center;">抱歉,暂无相关店铺!</span>
      </div>
      <shop-list :data="list"></shop-list>
      <div v-show="total>0" class="page-wrapper">
        <Page :total="total" :current="page" :page-size="pageSize" show-elevator show-total @on-change="changePage"></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { storeSearch } from 'api/home';
import shopList from './module-shopList.vue';
export default {
  components: {
    shopList
  },
  data() {
    return {
      list: [],
      keywords: "",
      searchType: "default",
      page: 1,
      pageSize: 10,
      loading: false,
      total: 0
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "店铺列表") {
        this.keywords = this.$route.query.keywords || "";
        this.page = 1;
        this.list = [];
        this.fetchData();
      }
    }
  },
  created() {
    this.keywords = this.$route.query.keywords || "";
    this.fetchData();
  },
  methods: {
    changePage(index) {
      this.page = index;
      this.fetchData();
    },
    changeSearchByType(type) {
      this.searchType = type;
      this.fetchData();
    },
    fetchData() {
      if (!this.loading) {
        this.total = 0;
        this.loading = true;
        let keywords = this.$route.query.keywords || "";
        storeSearch(this.page, this.pageSize, keywords, this.searchType).then(json => {
          if (json.resCode == 1) {
            this.loading = false;
            let data = json.data;
            this.list = data.list;
            this.total = data.total;
          } else {
            console.log("获取店铺列表数据错误！")
          }
        });
      };
    }
  }
}
</script>
<style scoped>
#goods-list-page .wrapper {
  width: 1200px !important;
  margin: 0 auto;
}
.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// shop-list.vue?33a7bb14